import { create } from 'zustand'

const UserState = create<UserStateInterface>((set) => {
    const UserInitialState: UserStateInterface = {
        User: null,
        Loading: true,
        SmallLoading: false,
        SetState: (payload: UserInterface) => set((state: UserStateInterface) => ({
            ...state,
            ...payload
        }))
    }

    return UserInitialState
})

export default UserState
